import React, { useEffect, useState } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import auth from "../../utilities/Auth";
import { Dialog } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";
import authUtility from "../../utilities/AuthUtility";
import i18next from "i18next";
import History from "../../utilities/History";
import getLicenseDetailsStore from "../../flux/stores/license/GetLicenseDetailsStore";
import licenseActions from "../../flux/actions/LicenseActions";

interface IRoutes {
  authKey?: Array<any>;
  component: any;
  layout: any;
  rest?: any;
  path: string;
  exact: boolean;
  location?: any;
}

const AppRoutes: React.FC<IRoutes> = ({
  authKey: authKey,
  component: Component,
  layout: Layout,
  ...rest
}) => {
  const [isLicenseExpired, setIsLicenseExpired] = useState(false);
  const [isLicenseExpiredCounter, setIsLicenseExpiredCounter] = useState(false);
  // const [counter, setCounter] = useState(60);
  const [counter, setCounter] = useState(() => {
    // Retrieve the counter value from local storage, defaulting to 60 if not available
    const storedCounter = localStorage.getItem("counter");
    return storedCounter ? parseInt(storedCounter) : 60;
  });
  const [licenseDetails, setLicenseDetails] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);
  const [licenseExpiryDate, setLicenseExpiryDate] = useState(null);
  const [isLicenseApplicable, setisLicenseApplicable] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const location = useLocation();

  const dateFormat = (date: string) => {
    let dateObj = new Date(date);
    return dateObj.toDateString();
  }

  useEffect(() => {
    const handleStoreChange = (state: any) => {
      setLicenseDetails(state.licenseData.data);
    };
    getLicenseData();
    getLicenseDetailsStore.on(CONSTANTS.CHANGE_EVENT, handleStoreChange);
    return () => {
      getLicenseDetailsStore.off(CONSTANTS.CHANGE_EVENT, handleStoreChange);
    };
  }, []);

  useEffect(() => {
    if (licenseDetails && !dataFetched) {
      getLicenseData();
      setDataFetched(true);
    }
  }, [licenseDetails, dataFetched]);

  const getLicenseData = () => {
    licenseActions
      .getLicenseDetails()
      .then(async () => {
        let responses: any = licenseDetails?.filter((x: any) => x.isActive === true && x.hasValidLicense === true);
        let isAnyLicenseNotApplicable = licenseDetails?.some((node: any) => !node.isLicenseApplicable);
        // let responses: any = await import('../../../public/test.json');
        // let isAnyLicenseNotApplicable: any = responses.default.some((node: any) => !node.isLicenseApplicable);
        // responses = responses.default.filter((x: any) => x.isActive === true && x.hasValidLicense === true);
        let response: any;
        if (!isAnyLicenseNotApplicable) {
          if (responses) {
            response = responses.length !== 0 ? responses[0] : [];
          }
          if (response !== undefined) {
            if (responses?.length !== 0 || response.length !== 0) {
              if (response?.isLicenseApplicable) {
                setisLicenseApplicable(true);
                if (response.hasValidLicense) {
                  if (!response.isLifeTimeLicense) {
                    setExpirationDate(dateFormat(response?.expiryDate));
                    const expiryDate = new Date(response.expiryDate);
                    // Subtract 10 seconds from the expiry date
                    expiryDate.setSeconds(expiryDate.getSeconds());
                    // if (expiryDate.getTime() !== licenseExpiryDate?.getTime()) {
                    //   setLicenseExpiryDate(expiryDate);
                    // }
                    setLicenseExpiryDate(expiryDate);
                    const date: any = new Date(response.expiryDate);
                    const currentDate: any = new Date();
                    const diffInMs = date - currentDate;
                    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

                    const lastPopup = localStorage.getItem('lastPopup');
                    const lastPopupDate: any = lastPopup ? new Date(lastPopup) : null;
                    const daysSinceLastPopup = lastPopupDate ? (currentDate - lastPopupDate) / (1000 * 60 * 60 * 24) : null;
                    let hasLoggedOut = localStorage.getItem(CONSTANTS.HAS_LOGGED_OUT);

                    if ((diffInDays <= 180 && (!lastPopupDate || daysSinceLastPopup >= 180)) ||
                      (diffInDays <= 90 && (!lastPopupDate || daysSinceLastPopup >= 90)) ||
                      (diffInDays <= 30 && (!lastPopupDate || daysSinceLastPopup >= 30)) ||
                      (diffInDays <= 7 && (!lastPopupDate || daysSinceLastPopup >= 1))) {
                      setIsLicenseExpired(true);
                      // Update the last popup date
                      localStorage.setItem('lastPopup', currentDate.toString());
                      // Reset the logout status
                      localStorage.setItem(CONSTANTS.HAS_LOGGED_OUT, 'false');
                    }
                    if (lastPopupDate && new Date(lastPopupDate).toDateString() === new Date(currentDate).toDateString() && hasLoggedOut && hasLoggedOut === 'true') {
                      setIsLicenseExpired(true);
                      // Update the last popup date
                      localStorage.setItem('lastPopup', currentDate.toString());
                      // Reset the logout status
                      localStorage.setItem(CONSTANTS.HAS_LOGGED_OUT, 'false');
                    }
                  } else {

                  }
                } else {
                  logout();
                }
              } else {
                setisLicenseApplicable(false);
              }
            } else {
              logout();
            }
          }
        }

      })
      .catch((error) => {
        logout();
      });
  }

  useEffect(() => {
    console.log("Effect triggered");
    if (licenseExpiryDate && location.pathname !== '/login') {
      console.log("Inside effect with licenseExpiryDate:", licenseExpiryDate);
      const formattedDate = new Date(licenseExpiryDate);
      const currentTime = new Date();
      const timeUntilExpiry = formattedDate.getTime() - currentTime.getTime();
      console.log("Time until expiry:", timeUntilExpiry);
      const threshold = 60000; // 60 seconds
      const maxDelay = 2147483647; // Maximum delay value for setTimeout

      if (timeUntilExpiry - threshold > maxDelay) {
        console.log("Delay exceeds max threshold, returning");
        // If the delay would exceed the maximum value, don't set a timeout
        return;
      }

      const timerId = setTimeout(() => {
        console.log("License expired");
        setIsLicenseExpiredCounter(true);
        const countdownTimerId = setInterval(() => {
          setCounter((prevCounter) => {
            if (prevCounter <= 1) {
              setIsLicenseExpiredCounter(false);
              clearInterval(countdownTimerId);
              logout();
              return 0;
            }
            return prevCounter - 1;
          });
        }, 1000);

        return () => {
          clearInterval(countdownTimerId);
        };
      }, timeUntilExpiry - threshold);

      return () => {
        console.log("Clearing timeout");
        clearTimeout(timerId);
      }
    }
  }, [licenseExpiryDate]);

  useEffect(() => {
    localStorage.setItem("counter", counter.toString());
  }, [counter]);

  useEffect(() => {
    const licenseExpiredCounter = false;
    setIsLicenseExpiredCounter(licenseExpiredCounter);
  }, []);

  const closePopup = () => {
    setIsLicenseExpired(false);
    setIsLicenseExpiredCounter(false);
  };

  const logout = (): void => {
    auth.removeTokens();
    localStorage.removeItem("counter");
    History.push(CONSTANTS.LOGIN_URL);
  };

  const ConfigurationClick = (): void => {
    setIsLicenseExpired(false);
    History.push(CONSTANTS.LICENSE_MANAGEMENT_INDEX_URL);
  };

  return (
    <>
      <Route
        {...rest}
        // tslint:disable-next-line: jsx-no-lambda
        render={(props) => {
          if (auth.isLoggedIn()) {
            if (
              (props.location.pathname.toString() === "/" ||
                props.location.pathname.toString().includes("login"))
            ) {
              return (
                <Redirect
                  to={{
                    pathname: CONSTANTS.SAMPLE_INDEXNEW_URL,
                    state: { from: props.location },
                  }}
                />
              );
            }
            return (
              <Layout {...props}>
                {authUtility.hasPermission(authKey) &&
                  <Component {...props} />}
              </Layout>
            );
          } else if (props.location.pathname.toString().includes("login")) {
            return (
              <Layout {...props}>
                <Component {...props} />
              </Layout>
            );
          } else {
            return (
              <Redirect
                to={{
                  pathname: CONSTANTS.LOGIN_URL,
                  state: { from: props.location },
                }}
              />
            );
          }
        }}
      />
      {
        isLicenseExpired && (
          <Dialog
            isOpen={isLicenseExpired}
            onClose={closePopup}
            showCloseButton={true}
            closeOnEscape={false}
            closeOnLostFocus={false}
            dimBackground={true}
            title={i18next.t(CONSTANTS.LICENSE_WARNING_HEADNG)}
            standardButtonsOnBottom={(location.pathname !== '/login' && authUtility.hasPermission([`${CONSTANTS.AUTHKEY_LICENSE_MANAGEMENT}`])) ? [
              {
                text: `${i18next.t(CONSTANTS.CONFIGURATION_BUTTON)}`,
                type: "primary-blue",
                handler: ConfigurationClick,
              },
              {
                text: "OK",
                type: "primary-blue",
                handler: (dlg) => dlg.close(),
              },
            ] : [
              {
                text: "OK",
                type: "primary-blue",
                handler: (dlg) => dlg.close(),
              },
            ]}
          >
            <div>
              {i18next.t(
                CONSTANTS.LICENSE_WARNING_TEXT1.format(
                  expirationDate
                )
              )}
              <br />
              <br />
              {i18next.t(CONSTANTS.LICENSE_WARNING_TEXT2)}
            </div>
          </Dialog>
        )}
      {
        isLicenseExpiredCounter && (
          <Dialog
            isOpen={isLicenseExpiredCounter}
            onClose={closePopup}
            showCloseButton={true}
            closeOnEscape={false}
            closeOnLostFocus={false}
            dimBackground={true}
            title={i18next.t(CONSTANTS.LICENSE_WARNING_HEADNG)}
            standardButtonsOnBottom={[
              {
                text: "OK",
                type: "primary-blue",
                handler: (dlg) => dlg.close(),
              },
            ]}
          >
            <div>
              {i18next.t(
                CONSTANTS.LICENSE_COUNTER_TEXT1.format(
                  expirationDate
                )
              )}
              {i18next.t(CONSTANTS.LICENSE_COUNTER_TEXT2)} {counter} {i18next.t(CONSTANTS.LICENSE_SECONDS_TEXT)}
            </div>
          </Dialog>
        )}
    </>
  );
}
export default AppRoutes;
